function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" {...props}><path fill="#DE002E" d="M20 .256C9.128.256.256 9.128.256 20S9.128 39.744 20 39.744 39.744 30.872 39.744 20 30.872.256 20 .256zm1.026 27.95a1.27 1.27 0 0 1-1.282 1.281 1.27 1.27 0 0 1-1.282-1.282v-1.538a1.27 1.27 0 0 1 1.282-1.282 1.27 1.27 0 0 1 1.282 1.282v1.538zm0-6.155a1.27 1.27 0 0 1-1.282 1.282 1.27 1.27 0 0 1-1.282-1.282v-9.743a1.27 1.27 0 0 1 1.282-1.282 1.27 1.27 0 0 1 1.282 1.282v9.743z" /></svg>;
});